module.exports = __webpack_public_path__ + "static/media/Media & Entertainment Collection.33956430.png";